import React, { useEffect, useState } from "react";
import { fetchFromStrapi } from "../api/strapi";

export default function Awards() {
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetchFromStrapi("/ecl-awards");
        const awardList = res?.data?.data || res?.data || [];
        console.log("Fetched awards:", awardList);
        setAwards(awardList);
      } catch (err) {
        console.error("Failed to fetch awards:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const getImageUrl = item =>
    item?.attributes?.image?.data?.attributes?.url;

  if (loading) return null;

  return (
    <section className="py-5 bg-white" style={{marginBottom: '80px'}}>
      <div className="container">

        {/* Section Header */}
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3">Awards & Recognition</h2>

          {/* Gold Divider */}
          <div
            style={{
              width: 60,
              height: 3,
              backgroundColor: "#C6A75E",
              margin: "0 auto 20px",
            }}
          />

          <p
            className="text-muted mb-0"
            style={{ maxWidth: 600, margin: "0 auto" }}
          >
            Recognition that reflects our commitment to excellence and innovation.
          </p>
        </div>

        {/* Awards Grid */}
        <div className="row g-4">
          {awards.map((item, index) => (
            <div
              key={index}
              className="col-md-4"
            >
              <div className="award-card bg-white rounded-4 h-100 text-center p-4">

                {/* Award Image */}
                <div
                  className="mb-4 d-flex align-items-center justify-content-center"
                  style={{ height: 170 }}
                >
                  <img
                    src={getImageUrl(item)}
                    alt={item.attributes.Title}
                    className="img-fluid"
                    style={{
                      maxHeight: 150,
                      objectFit: "contain",
                    }}
                  />
                </div>

                {/* Year Badge */}
                {item.attributes.Year && (
                  <div
                    className="mb-3"
                    style={{
                      display: "inline-block",
                      padding: "4px 14px",
                      fontSize: 13,
                      borderRadius: 30,
                      border: "1px solid #C6A75E",
                      color: "#C6A75E",
                      fontWeight: 500,
                    }}
                  >
                    {item.attributes.Year}
                  </div>
                )}

                {/* Award Title */}
                <h6 className="fw-semibold mb-0 mt-2">
                  {item.attributes.Title}
                </h6>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
